import { t } from 'i18next'
import { ToastEventPayload } from '~/hooks/toast/useToastAlerts'
import {
  NotificationDomain,
  NotificationPayload,
} from '~/services/EventEmitter/types/NotificationEmitterTypes'

export enum FaxOperation {
  Send = 'send',
  Delete = 'delete',
}

export type FaxOperationContext = {
  [FaxOperation.Send]: never
  [FaxOperation.Delete]: number
}

const getSendFaxToastEvent = (
  payload: NotificationPayload<NotificationDomain.FAX>,
) => {
  let title = ''
  let showToast = true

  switch (payload.disposition) {
    case 'success':
      title = t('faxPage.toast.sendSuccess')
      break
    case 'error':
      title = t('faxPage.toast.sendError')
      break
    default: {
      showToast = false
      break
    }
  }

  if (!showToast) {
    return
  }

  return {
    title,
    disposition: payload.disposition,
    durationMs: 3250,
  } as ToastEventPayload
}

//unhandled at this time
const getDeleteFaxToastEvent = (
  payload: NotificationPayload<NotificationDomain.FAX>,
) => {
  let title = ''
  let showToast = true

  switch (payload.disposition) {
    case 'success':
      title = t('faxPage.toast.deleteSuccess')
      break
    case 'error':
      title = t('faxPage.toast.deleteError')
      break
    default: {
      showToast = false
      break
    }
  }

  if (!showToast) {
    return
  }

  return {
    title,
    disposition: payload.disposition,
    durationMs: 3250,
  } as ToastEventPayload
}

export const getFaxToastEvent = (
  payload: NotificationPayload<NotificationDomain.FAX>,
) => {
  switch (payload.operation) {
    case FaxOperation.Send:
      return getSendFaxToastEvent(payload)
    case FaxOperation.Delete:
      return getDeleteFaxToastEvent(payload)
    default:
      return null
  }
}
